export * from './admin.service';
import { AdminService } from './admin.service';
export const APIS = [AdminService];
